import { Component, OnInit, ElementRef, Input, ViewEncapsulation, ViewChild, Output, EventEmitter } from '@angular/core';
import { Modal } from '../../components/modal/Modal';

declare var jQuery: any;

@Component({
  selector: 'image-cropper',
  template: `
    <div class="row">
      <input id="input-file" #inputFileUpload type="file" style="display:none" (change)="upload($event)" accept="image/*"/>
      <modal class="logo" #modal #modalEl (onClose)="closeModalEvent()" [backdrop]="true">
        <modal-header>
          <h3 class="no-margin">{{ limitExceeded ? 'Atenção' : 'Ajuste da imagem' }}</h3>
        </modal-header>
        <modal-content>

          <div class="row">
            <div class="col-xs-12 col-md-12">
              <div class="crop-container">
                <img #imgCrop class="crop-image" src=""/>
              </div>

              <div class="col-xs-12 col-md-12 cropper" *ngIf="!limitExceeded">
                <div class="btn-zoom">
                  <button type="button" class="btn btn-logo-tools" (click)="resizeWidth(200)">
                    <img src="./assets/shared/img/square.svg"></button>
                  <button type="button" class="btn btn-logo-tools" (click)="resizeWidth(400)">
                    <img src="./assets/shared/img/rectangular.svg"></button>
                  <button type="button" class="btn btn-logo-tools" [disabled]="!hasImage" (click)="zoom(0.1)">
                    <img src="./assets/shared/img/zoom-in.svg"></button>
                  <button type="button" class="btn btn-logo-tools" [disabled]="!hasImage" (click)="zoom(-0.1)">
                    <img src="./assets/shared/img/zoom-out.svg"></button>
                </div>
              </div>

            </div>

            <div class="col-xs-12 col-md-12" *ngIf="limitExceeded">
              <p>A imagem excede o limite de upload de 1MB. Por favor escolha outra imagem ou reduza o tamanho desta imagem.</p>
            </div>
          </div>

        </modal-content>
        <modal-footer>
          <button class="btn btn-primary" [disabled]="!hasImage" *ngIf="!limitExceeded" (click)="close()">OK</button>
          <button class="btn btn-primary" *ngIf="limitExceeded" (click)="closeModalEvent()">Voltar</button>
        </modal-footer>
      </modal>
    </div>
  `,
  styleUrls: ['./cropper.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CropperComponent implements OnInit {
  public hasImage = false;
  @Input() public imageWidth: number;
  @Input() public imageHeight: number;
  @ViewChild('modal') public modal: Modal;
  @ViewChild('imgCrop', { read: ElementRef }) public imgCrop: ElementRef;
  @ViewChild('inputFileUpload') public inputFileUpload: any;
  @Output('cropEvent') public cropEvent = new EventEmitter<any>();

  private cropImageEl: any;
  private inputFile: any;
  private inputFileEl: any;
  private image: any;
  private imageBase64: any;
  public limitExceeded = false;
  private newImageFile: any;
  private image_key: any;

  constructor(private _el: ElementRef) {
  }

  public ngOnInit(): void {
    this.cropImageEl = jQuery(this.imgCrop.nativeElement);
    this.inputFile = jQuery(this._el.nativeElement.querySelector('#input-file'));
  }

  public reset(): void {
    this.cropImageEl.attr('src', '');
    this.cropImageEl.cropper('destroy');
    this.hasImage = false;
    this.inputFileUpload.nativeElement.value = '';
  }

  public crop(): any {
    return this.cropImageEl.cropper('getCroppedCanvas').toDataURL('image/png');
  }

  public setImage(): void {
    this.inputFile.trigger('click');
  }

  public zoom(zoom): void {
    this.cropImageEl.cropper('zoom', zoom);
  }

  public resizeWidth(width): void {
    this.imageWidth = width;
    this.loadImage(this.imageBase64);
  }

  private loadImage(image): void {
    if (this.hasImage) {
      this.reset();
    }

    let aspectRatio = 1 / 1;
    if (this.imageWidth && this.imageHeight) {
      aspectRatio = this.imageWidth / this.imageHeight;
    }

    this.cropImageEl.attr('src', image);
    this.image = this.cropImageEl.cropper({
      aspectRatio,
      // minContainerWidth : '500',
      // minContainerHeight: '400',
      autoCropArea: 1,
      background: false,
      modal: false
      // , crop: (e) => {
      //   // Callback for the crop
      // }
      , ready: (e) => {
        const imageData = this.cropImageEl.cropper('getImageData');
        const canvasData = this.cropImageEl.cropper('getCanvasData');
        const cropBoxData = this.cropImageEl.cropper('getCropBoxData');

        if (imageData.aspectRatio > 1) {
          // Horizontal image
          this.cropImageEl.cropper('setCanvasData', {
            left: cropBoxData.left,
            width: cropBoxData.width,
          });

          const canvasDataNew = this.cropImageEl.cropper('getCanvasData');

          // Put image on center
          const top = (cropBoxData.height - canvasDataNew.height) / 2;
          this.cropImageEl.cropper('setCanvasData', {
            top: top,
          });

        }
      }
    });

    this.hasImage = true;
  }

  public upload(event): void {
    
    const input = event.target;
    if (input.files && input.files[0]) {
      this.open();
      this.newImageFile = input.files.item(0);
      const reader = new FileReader();

      reader.onload = (e) => {
        if (e['total'] > 1000000) {
          this.limitExceeded = true;
        } else {
          this.limitExceeded = false;
          this.imageBase64 = e.target['result'];
          this.loadImage(e.target['result']);
        }

      };
      reader.readAsDataURL(input.files[0]);
    } else {
      this.closeModalEvent();
    }
  }

  getWebpKey(path, name): string {
    const nameWithoutExtension = name.split('.').shift();
    return `${path}/${nameWithoutExtension}.webp`;
  }

  getImageName() {
    const isNewImage = this.newImageFile != null;
    if (isNewImage) {
      const fileExtension = this.newImageFile.name.split('.').pop();
      return `${Date.now().toString()}.${fileExtension}`;
    }
  
    if (this.image_key) {
      const fileExtension = this.image_key.split('.').pop();
      return `${Date.now().toString()}.${fileExtension}`;
    }
  
    return `${Date.now().toString()}`;
  }

  private open(): void {
    this.modal.open();
  }

  public close(): void {
    this.cropEvent.emit(true);
    this.modal.close();
    this.inputFileUpload.nativeElement.value = '';
  }

  public closeModalEvent(): void {
    this.modal.close();
    this.reset();
    this.inputFileUpload.nativeElement.value = '';
  }
}
